import React from 'react'
import PropTypes from 'prop-types'
import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

const EditorComponent = ({
  style,
  input_style,
  label, name, editorModelState, onEditorModelStateChange, hidden }) => {
  if (hidden) return null // Don't render if hidden

  return (
    <div className={`${style}`} >
      {label && <label className="form-label" htmlFor={name}>{label}</label>}
      <Editor
        editorState={editorModelState}
        onEditorStateChange={onEditorModelStateChange}
        toolbarClassName="editor-toolbar"
        wrapperClassName="editor-wrapper"
        editorClassName="editor-content"
        editorStyle={{
          border: '1px solid #C0C0C0',
          minHeight: '200px',
          padding: '10px',
          borderRadius: '5px',
          backgroundColor: '#fff'
        }}
      />
    </div>
  )
}

EditorComponent.propTypes = {
  style: PropTypes.string,
  input_style: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onEditorModelStateChange: PropTypes.func.isRequired,
  editorModelState: PropTypes.object.isRequired,
  hidden: PropTypes.bool,
}

export default EditorComponent
